import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

interface ValueSwitcherProps {
  alignment: string;
  handleChange: (
    value: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => void;
  background?: string;
  timing: { value: string; label: string }[];
}

const ValueSwitcher: React.FC<ValueSwitcherProps> = ({
  alignment,
  handleChange,
  background,
  timing,
}) => {
  return (
    <ToggleButtonGroup
      color="primary"
      value={alignment}
      exclusive
      onChange={(e, v) => v && handleChange(e, v)}
      aria-label="Platform"
      sx={{
        border: "0.5px solid #00000040",
        // borderRadius: "25px",
        background: background ?? "transparent",
        "& .css-vd0uz-MuiToggleButtonGroup-root , .MuiToggleButtonGroup-grouped:not(:last-of-type), .MuiToggleButtonGroup-grouped:not(:first-of-type) ":
          {
            // borderRadius: "25px",
            borderLeft: "none",
          },
        "& .css-1a5hvjr-MuiButtonBase-root-MuiToggleButton-root.Mui-selected": {
          color: "#054FA4",
          backgroundColor: "#79B6FB",
          border: "1px solid",
        },
      }}
    >
      {timing.map((item) => {
        return (
          <ToggleButton
            key={item.value}
            size="small"
            value={item.value}
            sx={{
              minWidth: "80px",
              padding: "5.5px",
              border: "none",
              // borderRadius: "25px",
              textTransform: "none",
            }}
          >
            {item.label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ValueSwitcher;
